import React from 'react';
import { Container } from 'src/components/Layout/Container';
import { Link } from 'react-router';
import { AccountIcon } from 'src/components/Header/AccountIcon';
import { OrderTrackingIcon } from 'src/components/Header/OrderTrackingIcon';
import { HeaderStore } from 'src/components/Header/HeaderStore';
import classnames from 'classnames';
import wrapperStyles from 'src/components/Layout/Wrapper.scss';

import classes from './SubHeader.scss';
import { useHeaderColor } from './hooks/useHeaderColor';
import { getBackgroundColorClassName } from './utils/Header';

export const SubHeader: React.FC<{ whiteIcons: boolean }> = ({ whiteIcons }) => {
    const backgroundColor = useHeaderColor();

    return (
        <div
            className={classnames([classes.wrapper].join(' '), {
                ...getBackgroundColorClassName(wrapperStyles, backgroundColor),
            })}
        >
            <Container className={classnames(classes.container, { [classes.whiteIcons]: whiteIcons })}>
                <OrderTrackingIcon whiteIcons={whiteIcons} />
                <Link to="/contact-us" className={classnames({ [classes.whiteIcons]: whiteIcons })}>
                    <img src={require('../../../static/icons/need-help.svg')} alt="need help icon" />
                    <span>Need Help</span>
                </Link>
                <a
                    href="http://workwearexpresscorporate.netlify.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classnames({ [classes.whiteIcons]: whiteIcons })}
                >
                    <img src={require('../../../static/icons/bulk-corporate.svg')} alt="bulk and corporate icon" />
                    <span>Corporate Solutions & Pricing</span>
                </a>
                <AccountIcon whiteIcons={whiteIcons} />
                <HeaderStore bg={backgroundColor} className={classes.headerStore} whiteIcons={whiteIcons} />
            </Container>
        </div>
    );
};
